import { useEffect, useState } from "react";

interface useKeyListenerProps {}

export const useKeyListener = () => {
    /* ******************** Hooks ******************** */
    /* ******************** Variables ******************** */
    const [currKey, setCurrKey ] = useState<string | null>(null);
    /* ******************** Functions ******************** */
    const handleKeyDown = (event: KeyboardEvent) => {
        setCurrKey(event.key)
    }
    const handleKeyUp = (event: KeyboardEvent) => {
        if (event.key === currKey) setCurrKey(null);
    }
    /* ******************** Effects ******************** */
    useEffect(() =>{
        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('keyup', handleKeyUp);
        return () =>{
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('keyup', handleKeyUp);
        }
    }, [])
    /* ******************** JSX ******************** */
    return {
        currKey
    }
}